import { lazyRouteComponent } from "@tanstack/react-router";
import { Zap } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const REGIONS = ["all", "india", "global"] as const;
export const LEVELS = ["major", "medium", "all"] as const;

export interface MarketNewsSearch {
  region: (typeof REGIONS)[number];
  level: (typeof LEVELS)[number];
  /** A category key (results, monetary_policy ...). */
  cat?: string;
  /** Only stories naming a share in my watchlists. */
  wl?: boolean;
  /** A story opened from an alert. */
  story?: number;
  /** A combined alert's stories ("Market news: 3 updates"). */
  stories?: string;
  /** Quick time filter: since this morning's brief, or the last 24 hours (default: live, 48 h). */
  when?: (typeof WHENS)[number];
}

export const WHENS = ["brief", "24h"] as const;

export function parseMarketNewsSearch(s: Record<string, unknown>): MarketNewsSearch {
  const story = Number(s.story);
  const cat = typeof s.cat === "string" && /^[a-z_]{1,30}$/.test(s.cat) ? s.cat : undefined;
  return {
    region: REGIONS.includes(s.region as MarketNewsSearch["region"]) ? (s.region as MarketNewsSearch["region"]) : "all",
    level: LEVELS.includes(s.level as MarketNewsSearch["level"]) ? (s.level as MarketNewsSearch["level"]) : "medium",
    ...(cat ? { cat } : {}),
    ...(s.wl === true || s.wl === "true" || s.wl === "1" ? { wl: true } : {}),
    ...(Number.isInteger(story) && story > 0 ? { story } : {}),
    ...(/^\d+(,\d+){0,49}$/.test(String(s.stories ?? "")) ? { stories: String(s.stories) } : {}),
    ...(WHENS.includes(s.when as (typeof WHENS)[number]) ? { when: s.when as (typeof WHENS)[number] } : {}),
  };
}

export const pages: PageDef[] = [
  {
    path: "/app/market-news",
    title: "Market news",
    component: lazyRouteComponent(() => import("./MarketNewsPage"), "MarketNewsPage"),
    nav: { label: "Market news", icon: Zap, group: "Markets", order: 44 },
    validateSearch: parseMarketNewsSearch,
  },
];
